export var FireblocksWebhookTypeEnum;
(function (FireblocksWebhookTypeEnum) {
    FireblocksWebhookTypeEnum["CREATE"] = "CREATE";
    FireblocksWebhookTypeEnum["UPDATE"] = "UPDATE";
})(FireblocksWebhookTypeEnum || (FireblocksWebhookTypeEnum = {}));
//# sourceMappingURL=fireblocks-webhook-type.enum.js.map